import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../../../CommonUtils/authFetch';

export interface TemplatesDTO {
  templateId: string;
  name: string;
  lastUpdated: string;
  isReadOnly: boolean;
}

const fetchPersonalFinanceTemplates = async (): Promise<TemplatesDTO[]> => {
  return authFetch('/Adviser/PersonalFinanceTemplates/GetAllTemplates');
};

export const usePersonalFinanceTemplatesQuery = () => {
  return useQuery(queryKeys.personalFinanceTemplates(), fetchPersonalFinanceTemplates);
};
